module.exports = __webpack_public_path__ + "img/frame (51).fb5213ef.jpg";